// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class MonthlyCostApportionment  {
    _originalTypeClassName = "Loom.BO.MonthlyCostApportionment";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
MonthlyCostApportionment.translate = translateService;
}
this.AllProjectsReport = new Domain.AllProjectsReport();
this.Id = null;
this.Month = null;
this.PaymentType = null;
this.ApportionedNetAmount = null;
this.ApportionedSocialSecurityAmount = null;
this.ApportionedTaxAmount = null;
this.PrivateInsuranceAmount = null;
this.CouponAmount = null;
this.CouponCommission = null;
this.EmployeeSalaryForMonth = null;
this.EmployeeBenefitsForMonth = null;
this.TotalEmployeeCostForMonth = null;
this.PercentageApportioned = null;
this.EmployeeName = null;
this.EmployeeAccountingCode = null;
this.ProjectAcronym = null;
this.ProjectAccountingCode = null;
this.Organisation = null;
this.ProjectHours = null;
this.TotalHoursThisMonthInProjects = null;
this.TotalDaysTheEmployeeWorkedThisMonth = null;
this.PercentageInProjectThisMonth = null;
this.ProjectCostClaimed = null;
this.TotalApportionedSalary = null;
this.TotalApportionedBenefits = null;
this.GrandTotalApportioned = null;
this.TotalCostsClaimedInProjectThisPeriod = null;
this.TotalCostsClaimedInProjectThisMonth = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Month:any;
PaymentType:any;
ApportionedNetAmount:any;
ApportionedSocialSecurityAmount:any;
ApportionedTaxAmount:any;
PrivateInsuranceAmount:any;
CouponAmount:any;
CouponCommission:any;
EmployeeSalaryForMonth:any;
EmployeeBenefitsForMonth:any;
TotalEmployeeCostForMonth:any;
PercentageApportioned:any;
EmployeeName:any;
EmployeeAccountingCode:any;
ProjectAcronym:any;
ProjectAccountingCode:any;
Organisation:any;
ProjectHours:any;
TotalHoursThisMonthInProjects:any;
TotalDaysTheEmployeeWorkedThisMonth:any;
PercentageInProjectThisMonth:any;
ProjectCostClaimed:any;
TotalApportionedSalary:any;
TotalApportionedBenefits:any;
GrandTotalApportioned:any;
TotalCostsClaimedInProjectThisPeriod:any;
TotalCostsClaimedInProjectThisMonth:any;
AllProjectsReport:any;
static setAllProjectsReport = ($this, value) => {
var oldValue = $this.AllProjectsReport;
$this.AllProjectsReport = value;
if (value != null) {
if (oldValue != null) {
Domain.AllProjectsReport.removeMonthlyCostApportionments(oldValue, $this);
}
Domain.AllProjectsReport.addMonthlyCostApportionments(value, $this);
}
}

static GetGrandTotalApportioned($this: any): any{return Joove.Common.safeNumber(Domain.MonthlyCostApportionment.GetTotalApportionedSalary($this)) + Joove.Common.safeNumber(Domain.MonthlyCostApportionment.GetTotalApportionedBenefits($this));
}
static GetTotalApportionedBenefits($this: any): any{return Joove.Common.safeNumber($this?.PrivateInsuranceAmount) + Joove.Common.safeNumber($this?.CouponAmount) + Joove.Common.safeNumber($this?.CouponCommission);
}
static GetTotalApportionedSalary($this: any): any{return Joove.Common.safeNumber($this?.ApportionedNetAmount) + Joove.Common.safeNumber($this?.ApportionedSocialSecurityAmount) + Joove.Common.safeNumber($this?.ApportionedTaxAmount);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}